import { render, staticRenderFns } from "./BackwardButton.vue?vue&type=template&id=587d0958&scoped=true"
import script from "./BackwardButton.vue?vue&type=script&lang=js"
export * from "./BackwardButton.vue?vue&type=script&lang=js"
import style0 from "./BackwardButton.vue?vue&type=style&index=0&id=587d0958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d0958",
  null
  
)

export default component.exports